var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRight = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_arrow_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon / chevron.left",
    d: "M16.6475 11.9476C16.6475 12.2749 16.5223 12.554 16.2624 12.8043L8.75405 20.149C8.5519 20.3608 8.28237 20.4667 7.97433 20.4667C7.34863 20.4667 6.8577 19.9854 6.8577 19.3501C6.8577 19.042 6.98284 18.7629 7.19461 18.5511L13.9618 11.9476L7.19461 5.34406C6.98284 5.12266 6.8577 4.84351 6.8577 4.53547C6.8577 3.90977 7.34863 3.42847 7.97433 3.42847C8.28237 3.42847 8.5519 3.53435 8.75405 3.74613L16.2624 11.0909C16.5223 11.3411 16.6378 11.6203 16.6475 11.9476Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-right.705bcd14d5f1c167a3ea79535fa0f588.svg";